(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0f70"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0f70"] = parcelRequire;
}
parcelRequire.register("9CzSz", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $70137e824f57299c$export$6503ec6e8aabbaf; }, function (v) { return $70137e824f57299c$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $70137e824f57299c$export$f7ad0328861e2f03; }, function (v) { return $70137e824f57299c$export$f7ad0328861e2f03 = v; });
var $70137e824f57299c$export$6503ec6e8aabbaf;
var $70137e824f57299c$export$f7ad0328861e2f03;
"use strict";
var $70137e824f57299c$var$mapping = {};
function $70137e824f57299c$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$70137e824f57299c$var$mapping[keys[i]] = pairs[keys[i]];
}
function $70137e824f57299c$var$resolve(id) {
    var resolved = $70137e824f57299c$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$70137e824f57299c$export$6503ec6e8aabbaf = $70137e824f57299c$var$register;
$70137e824f57299c$export$f7ad0328861e2f03 = $70137e824f57299c$var$resolve;

});

var $6159800cbc8e13e6$exports = {};

(parcelRequire("9CzSz")).register(JSON.parse('{"kd32O":"index.71d4a2ef.js","iRp1v":"api.64367342.js","9q0BT":"graphite_wasm_bg.7c2537a3.wasm","k6aPG":"thumbnail-just-a-potted-cactus.0c1da70d.png","hln9Y":"thumbnail-valley-of-spires.13f0179f.png","lHCYc":"index.3219de24.css"}'));

})();
//# sourceMappingURL=index.01ccf4c1.js.map
